import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import JobDetail from '@routes/Home/routes/Downloads/routes/JobDetail';

const LazyDownloadsLayout = React.lazy(
	() =>
		import(
			/* webpackChunkName: 'DownloadsLayout' */ './components/DownloadsLayout'
		)
);

const LazyDownloads = React.lazy(
	() => import(/* webpackChunkName: 'Downloads' */ './components')
);

export default () => ({
	path: 'downloads',
	element: <AsyncLoading component={<LazyDownloadsLayout />} />,
	children: [
		{
			index: true,
			element: <AsyncLoading component={<LazyDownloads />} />,
		},
		JobDetail(),
	],
});
